import React from "react";
import ShopifyModal from "../../../../components/ShopifyModal";

// ai优化积分不足
const Index = ({ 
  batchSourcingActive,
  batchSourcingLoading,
  handleBatchSourcingRequest,
  handleBatchSourcingActive,
  handleSourcingRequest,
  sourceProductId
}) => {

  return (
    <div>
      <ShopifyModal
        id="bulk-sourcing-modal"
        open={batchSourcingActive}
        onClose={() => handleBatchSourcingActive(false)}
        heading={sourceProductId !== '' ? "Sourcing Request" : 'Bulk Sourcing Request'}
        primaryAction={{
          content: 'Confirm',
          onAction: ()=>{
            if (sourceProductId !== '') {
              handleSourcingRequest()
            }else {
              handleBatchSourcingRequest()
            }
          },
          loading: batchSourcingLoading
        }}
        secondaryActions={[
          {
            content: 'Cancel',
            onAction: () => handleBatchSourcingActive(false),
          },
        ]}
      >
        {sourceProductId !== '' ? "Are you sure you want to source this product? Once your request is processed, the product supplier will be changed to Dropshipman." : 'Are you sure to source these products in bulk? After we complete your request, the supplier of these products will change to Dropshipman.'}
      </ShopifyModal>
    </div>
  );
};

export default Index;
